import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";

interface WorkFlowModalProps {
    open: boolean;
    expJson: any;
    fonts:any;
    baseUrl: string;
    handleClose?: (modalOpen: boolean) => void;
    notifyExpJson?: (args: any, state: string) => void;
}

const Storage       = require("shared/services/Storage");

export function BehaviorModal(props: WorkFlowModalProps) {
    const modalOpen = props.open || false;
    const [behaviorName, setBehaviorName] = useState("");
    const [shouldPrompt, setShouldPrompt] = useState(false);
    const [source, setSource] =useState({} as any)
    
    useEffect (() => {
        window.addEventListener("message", handleMessage, true);

        return () => {
            window.removeEventListener("message", handleMessage, true);
          }
    }, [window]);

    const handleInitialisation = (src) => {
        const token = Storage.Local.get(Storage.Keys.LOGIN, "token") || Storage.Session.get(Storage.Keys.LOGIN, "token");
        const behaviorData  = {
            expJson: props.expJson,
            token: token,
        }
        setSource(src);
        src.postMessage({type: "behaviorData", behaviorData: JSON.stringify(behaviorData)}, props.baseUrl);
    }

    const handleMessage = (event)  => {
        switch (event.data.type) {
            case "behaviorInit":
                handleInitialisation(event.source);
                break;
            case "shouldPrompt":
                setShouldPrompt(event.data.shouldPrompt);
                break;
            case "handleSave":
                closeModal();
                break;
            case "behaviorSaved": {
                setShouldPrompt(event.data.shouldPrompt)
                props.notifyExpJson(event.data.expJson, "saved");
                closeModal();
                break;
            }
            case "behaviorRemoved":
                props.notifyExpJson(event.data.expJson, "delete");
                break;
            case "behaviorName": 
                setBehaviorName(event.data.behaviorName);
            default:
                break;
        }
    }

    const closeModal = () => {
        props.handleClose(false);
    };

    const confirmCloseModal = () => {
        if(shouldPrompt)source.postMessage({type: "confirmCloseModal"}, props.baseUrl);
        else closeModal();
   };

    return (
        <div>
            <Modal
                aria-labelledby="contained-modal-title-vcenter"
                show={modalOpen}
                fullscreen="true"
                dialogClassName="full-screen"
                onHide={confirmCloseModal}
                backdrop="static"
                keyboard={false}
            >
                <Modal.Header closeButton> 
                <Modal.Title>Manage Behaviors {behaviorName ? `[${behaviorName}]` : null}</Modal.Title>
                </Modal.Header>
                <Modal.Body className = "iframe-container">
                    <iframe id="behaviorui" src={props.baseUrl} allow="clipboard-read; clipboard-write"></iframe>
                </Modal.Body>
            </Modal>
        </div>
    );
}



// WEBPACK FOOTER //
// ./src/editor/ui/experience/action/behavior/BehaviorModal.tsx